import camelcase from 'camelcase-keys';
import { stringify, parse } from 'qs';
import { omit } from 'lodash-es';

import { clientHttp } from 'common/http';

// As we're sending our requests to BE services via api g/w proxy built-in to
// ohou.se-client, using the endpoint without a hostname here:
const SHARE_LINK_QUERY_PARAMS_EXCLUSION_LIST = ['affect_id', 'affect_type'];

export interface CreateShareLinkParams {
  locationHref: string;
  onlyWeb: boolean;
  contentType: string;
  contentId: number;
  userId?: number | null;
}

export interface CreateShareLinkResult {
  url?: string;
}

export async function createShareLink({
  locationHref,
  onlyWeb,
  contentType,
  contentId,
  userId,
}: CreateShareLinkParams): Promise<CreateShareLinkResult> {
  // parse the given url with a minimal regex pattern
  const match = /^([^?#]+)(\?[^?#]*)?(#.+?)?$/.exec(locationHref);
  if (match == null) {
    throw new Error('invariant: invalid `locationHref`');
  }

  // here we drop the `hash` part
  const [, leadingUrlPart, search] = match;
  let serializedQuery = '';
  if (search != null) {
    const originalQuery = parse(search);
    // According to the spec, they want to strip some of useless params from querystring for the sake of ease processing
    // > https://docs.google.com/document/d/1TW7MPUCYIYK21-DfBc1kB58qp_ICRCYCsm-fTNdkDok
    const filteredQuery = omit(originalQuery, SHARE_LINK_QUERY_PARAMS_EXCLUSION_LIST);
    serializedQuery = `?${stringify(filteredQuery)}`;
  }

  const json = await clientHttp.post('/api/share/link', {
    json: {
      location_href: `${leadingUrlPart}${serializedQuery}`,
      only_web: onlyWeb,
      content_type: contentType,
      content_id: contentId,
      user_id: userId ?? null,
    },
  }).json();

  return camelcase(json as any, { deep: true }) as CreateShareLinkResult;
}
